import { FinancialsService } from '../services/financials.service';

/**
 * Resyncs financial integration data from the external connection and optionally
 * triggers a refresh callback. Use when Excel integration is saved and a financial
 * entity id exists.
 */
export async function resyncFinancialIntegration(
  entityId: number,
  onRefresh?: () => void,
): Promise<void> {
  const financialsService = new FinancialsService();
  await financialsService.resyncIntegration(entityId);
  onRefresh?.();
}
